/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date: 2018-11-22 15:45:42
 * @Last Modified by: qiuz
 * @Last Modified time: 2018-11-22 17:41:17
 */

import './index.less';

import * as React from 'react';

export default class LayoutFooter extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
	}

	render() {
		return (
			<footer className="layout_footer">
				<div className="footer_remark">
					<p>上海菲畅汽车服务有限公司  www.shfcqc.com</p>
					<p> 2018  ©All Rights Reserved	</p>
				</div>
				<a href="http://beian.miit.gov.cn/">沪ICP备18000052号</a>
			</footer>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component/footer/index.tsx